import { makeLogger } from "@/shared/consola";
import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const logger = makeLogger("player-certificates.service");

const makeCertificatesEndpoint = (playerUUID) => `players/${playerUUID}/certificates`;

export const playerCertificatesService = {
    async getCertificateTemplate(playerUUID) {
        logger.trace(`getCertificateTemplate(${playerUUID}) fired!`);
        return ajaxCall.get(makeCertificatesEndpoint(playerUUID));
    },
    async newCertificateTemplate(
        playerUUID,
        { isActive, issueImpossibleBefore, progressThreshold, templateName, content } = {}
    ) {
        logger.trace(`newCertificateTemplate(${playerUUID}) fired!`);
        return ajaxCall
            .post(makeCertificatesEndpoint(playerUUID), {
                isActive,
                issueImpossibleBefore,
                progressThreshold,
                templateName,
                content,
            })
            .catch(handleErrorByMessage());
    },
    // certId is not required because there might be only one cert template per player!
    async updateCertificateTemplate(
        playerUUID,
        { isActive, issueImpossibleBefore, progressThreshold, templateName, content } = {}
    ) {
        logger.trace(`updateCertificateTemplate(${playerUUID}) fired!`);
        return ajaxCall
            .patch(`${makeCertificatesEndpoint(playerUUID)}`, {
                isActive,
                issueImpossibleBefore,
                progressThreshold,
                templateName,
                content,
            })
            .catch(handleErrorByMessage());
    },
};
